export const COMPLETE_EVENT = 'Complete';
export const LEAD_EVENT = 'Lead';
export const VIEW_REACTIVATION_EVENT = 'ViewReactivation';
export const REACTIVATION_EVENT = 'ReactivateAccount';
export const GENERIC_AHOY_EVENT = 'Event';
export const POPULATE_DATA_LAYER = 'PopulateDataLayer';
export const ADD_TO_CART_EVENT = 'AddToCart';
export const BEGIN_CHECKOUT_EVENT = 'BeginCheckout';
